<template>
  <b-card no-body>
    <div class="shadow">
      <b-card-title
        class="d-flex justify-content-between align-items-center cursor-pointer m-2"
        @click="collapse_state = !collapse_state"
      >
        {{ $t('clients.contract') }} {{ contract.contract_number }}
        <b-button
          variant="link">
          <feather-icon
            size="18"
            icon="ChevronDownIcon"
          />
        </b-button>
      </b-card-title>
      <b-collapse v-model="collapse_state">
        <b-row class="p-2">
          <b-col
            md="6"
            sm="12"
            class="border-right"
          >
            <div class="d-flex justify-content-between">
              <span>
                {{ $t('clients.total_summ') }}
              </span>
              <b>
                {{ $_moneyFormatter(contract.total_price) }}
              </b>
            </div>
          </b-col>
          <b-col
            md="6"
            sm="12"
          >
            <div
              v-if="contract.installment_plan"
              class="d-flex justify-content-between"
            >
              <span>
                {{ $t('clients.installments_expiration') }}
              </span>
              <b>
                {{ contract.installment_plan.length }} {{ $t('clients.month') }}
              </b>
            </div>
          </b-col>
        </b-row>
        <div class="my-2">
          <h2 class="text-center">
            {{ $t('finance.scale_payment') }}:
          </h2>
          <div class="d-flex justify-content-center mx-5 mt-2 flex-wrap">
            <div
              v-for="(payment, index) in contract.installment_plan"
              :key="payment.id"
              class="text-center"
            >
              <div>
                <span class="font-weight-bold">{{ index + 1 }}</span>
              </div>
              <b-button
                v-if="payment.status === 'paid'"
                class="btn btn-success mx-1 mb-1"
              />
              <b-button
                v-if="payment.status === 'unpaid'"
                class="btn btn-danger mx-1 mb-1"
              />
              <b-button
                v-if="payment.status === 'partial'"
                class="btn btn-warning mx-1 mb-1"
              />
            </div>
          </div>
        </div>
        <!-- проведенные платежы -->
        <b-card class="bg-light">
          <b-card-title
            class="d-flex justify-content-between align-items-center cursor-pointer mb-0"
            @click="paid_payments = !paid_payments"
          >
            {{ $t('clients.paid_payments') }}
            <b-button
              variant="link"
              @click="paid_payments = !paid_payments"
            >
              <feather-icon
                size="18"
                icon="ChevronDownIcon"
              />
            </b-button>
          </b-card-title>
        </b-card>
        <b-collapse
          v-model="paid_payments"
          class="table-payments"
        >
          <div
            v-for="(payment,index) in getPaidInstalmens"
            :key="payment.id"
            class="d-flex payment justify-content-around align-items-center text-center p-1"
          >
            <b>
              {{ index + 1 }}
            </b>
            <b>
              {{ $t('clients.paid') }}: {{ $_dateTimeFormatter(payment.pay_date).split(',')[0] }}
            </b>
            <b>
              {{ $_moneyFormatter(payment.paid) }}
              <!--              {{ $_moneyFormatter(payment.partial) }}-->
            </b>
          </div>
        </b-collapse>
        <!-- предстоящии платежы -->
        <b-card class="bg-light">
          <b-card-title
            class="d-flex justify-content-between align-items-center cursor-pointer mb-0"
            @click="unpaid_payments = !unpaid_payments"
          >
            {{ $t('finance.upcoming_payments') }}
            <b-button
              variant="link"
              @click="unpaid_payments = !unpaid_payments"
            >
              <feather-icon
                size="18"
                icon="ChevronDownIcon"
              />
            </b-button>
          </b-card-title>
        </b-card>
        <b-collapse
          v-model="unpaid_payments"
          class="table-payments"
        >
          <div
            v-for="(payment, index) in getUnPaidInstalmen"
            :key="payment.id"
            class="d-flex payment align-items-center p-1 justify-content-around"
          >
            <b>
              {{ index + 1 }}
            </b>
            <b>
              {{ $_moneyFormatter(payment.amount) }}
            </b>
            <b>
              {{ $t('clients.pay_till') }}: {{ $_dateTimeFormatter(payment.pay_date).split(',')[0] }}
            </b>
          </div>
        </b-collapse>
      </b-collapse>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BButton, BCollapse, BRow, BCol,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapGetters } from 'vuex'
import formatter from '@/mixins/extra'

export default {
  components: {
    BCard,
    BCardTitle,
    BButton,
    FeatherIcon,
    BCollapse,
    BRow,
    BCol,
  },
  mixins: [formatter],
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      collapse_state: false,
      unpaid_payments: false,
      paid_payments: false,
      fields: [
        {
          key: '',
          label: '',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('clients', ['GET_PAYMENT_INTALLMENTS']),
    getPaidInstalmens() {
      if (this.contract.installment_plan) {
        // return this.contract.installment_plan.filter(el => el.status === 'paid' || el.status === 'partial')
        return this.contract.installment_plan.filter(el => ['paid', 'partial'].includes(el.status))
      }
      return []
    },
    getUnPaidInstalmen() {
      if (this.contract.installment_plan) {
        return this.contract.installment_plan.filter(el => ['unpaid'].includes(el.status))
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.table-payments div.payment:nth-child(odd) {
  background: #e0e0e0;
}

.table-payments div.payment:nth-child(even) {
  background: #ffffff;
}
</style>
